import { Stack, Heading, Text } from 'braid-design-system';
import type React from 'react';

type StackChild = React.ComponentProps<typeof Stack>['children'];

const SellingMessage = ({ children }: { children?: StackChild }) => (
  <Stack space="large">
    <Heading level="2">Selling a franchise?</Heading>
    <Text size="small">We make it easy to find high quality franchisees.</Text>
    {children}
  </Stack>
);

export default SellingMessage;
